import {
    CREATE_TEST_REQUEST,
    CREATE_TEST_SUCCESS,
    CREATE_TEST_FAIL,
    GET_TEST_DETAIL_REQUEST,
    GET_TEST_DETAIL_SUCCESS,
    GET_TEST_DETAIL_FAIL,
    DELETE_TEST_REQUEST,
    DELETE_TEST_SUCCESS,
    DELETE_TEST_FAIL,
    UPDATE_TEST_REQUEST,
    UPDATE_TEST_SUCCESS,
    UPDATE_TEST_FAIL,
    GET_TESTS_LIST_REQUEST,
    GET_TESTS_LIST_SUCCESS,
    GET_TESTS_LIST_FAIL,
} from './actionTypes';

const INIT_STATE = {
    tests: [],
    error: "",
  isLoading: false,
    test: {},
}
const TestReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case CREATE_TEST_REQUEST:
        case DELETE_TEST_REQUEST:
        case UPDATE_TEST_REQUEST:
        case GET_TEST_DETAIL_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case CREATE_TEST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                 test: action.payload,
                // tests:[...state.tests, action.payload],
            };
        case CREATE_TEST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case GET_TESTS_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_TESTS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                //test: action.payload,
                tests: action.payload,
            };
        case GET_TESTS_LIST_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case UPDATE_TEST_SUCCESS:
            return { 
                ...state,
                isLoading: false,
                tests: state.tests.map(test =>
                  test.id.toString() === action.payload.id.toString()
                    ? { test, ...action.payload }
                    : test
                ),
              
                    
            };
        case UPDATE_TEST_FAIL:
        case DELETE_TEST_FAIL:
        case GET_TEST_DETAIL_FAIL:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case DELETE_TEST_SUCCESS:
            return {
                ...state,
                tests: state.tests.filter(
                test => test.id.toString() !== action.payload.id.toString()
                ),
        }
        case GET_TEST_DETAIL_SUCCESS:
        return {
          ...state,
          isLoading: false,
          test: action.payload,
        
        }
  

    

        default:
            return state;

}
}

export default TestReducer;